import type { SupportedRepubName } from './types';

export type BettingSplitsConfig = {
  comparisonBetsLabel: (marketDisplayName: string) => string;
  comparisonMoneyLabel: (marketDisplayName: string) => string;
  defaultEventDisplayName: string;
};

/**
 * Betting splits configurations for each republic
 */
export const BETTING_SPLITS_CONFIGS = {
  GZ: {
    comparisonBetsLabel: () => '% di scommesse 1X2',
    comparisonMoneyLabel: () => '% di distribuzione monetaria 1X2',
    // TODO: Revert to 'Serie A' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
  },
  OC: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    // TODO: Revert to 'EPL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
  },
  US: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    // TODO: Revert to 'NFL' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
  },
  WS: {
    comparisonBetsLabel: marketDisplayName => `% of ${marketDisplayName} Bets`,
    comparisonMoneyLabel: marketDisplayName => `% of ${marketDisplayName} Money`,
    // TODO: Revert to 'All' after World Cup 2026
    defaultEventDisplayName: 'World Cup 2026',
  },
} satisfies Record<SupportedRepubName, BettingSplitsConfig>;
